<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="entity-info" [hidden]="minimise || !formDataObj.entityName">
  <h3><span class="LayerLine1">Entity:</span><span class="LayerData1">{{ formDataObj.entityName + ' : ' + formDataObj.taxYearBegin + ' - ' + formDataObj.taxYearEnd }}</span></h3>
  <h3><span class="LayerLine1">Business:</span><span class="LayerData1">{{ formDataObj.meCode + ' - ' + formDataObj.meName }}</span></h3>
  <h3><span class="LayerLine1">Tax Code:</span><span class="LayerData1">{{ formDataObj.taxCode }}</span></h3>
</div>

<div class="modal-body no-modal-body-scroll" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!showFormLoader) {
<div>
    @if (batchSelect && defaultsMultipleSelected && defaultsMultipleSelected.length) {
<ul class="nav nav-pills" role="tablist">
      @for (item of defaultsMultipleSelected; track $index) {
<li [class.active]="activeTab === item.subForm">
        <a (click)="onTabSelect(item)" style="cursor: pointer;" class="btn-sm">{{ item.subForm }}</a>
      </li>
}
    </ul>
}

    <div class="tab-content tab-content-padding">
      <!-- F8820 -->
      @if (formNo === 'F8820') {

        <gtw-credits-part-iii-f8820
          [activeTab]="activeTab"
          [currentFormHeader]="currentFormHeader"
          [tableHeader]="tableHeader"
          [outerList]="outerList"
          [formList]="formList"
          (fieldChange)="onFieldChange($event.item, $event.value)"
          (dateChange)="onDateChange($event.item, $event.event)"
          (dateVariousChange)="onDateVariousChange($event)"
          (radioToggle)="onRadioToggleIn(formList, $event.item, $event.checked)">
        </gtw-credits-part-iii-f8820>
      
}

      <!-- F8912 -->
      @if (formNo === 'F8912') {

        <gtw-credits-part-iii-f8912
          [activeTab]="activeTab"
          [currentFormHeader]="currentFormHeader"
          [tableHeader]="tableHeader"
          [outerList]="outerList"
          [formList]="formList"
          (fieldChange)="onFieldChange($event.item, $event.value)"
          (dateChange)="onDateChange($event.item, $event.event)"
          (dateVariousChange)="onDateVariousChange($event)"
          (checkBox8912)="checkBoxHandler8912($event.lineKey, $event.attribKey, $event.attribCol)">
        </gtw-credits-part-iii-f8912>
      
}

      <!-- F8941 -->
      @if (formNo === 'F8941') {

        <gtw-credits-part-iii-f8941
          [activeTab]="activeTab"
          [currentFormHeader]="currentFormHeader"
          [tableHeader]="tableHeader"
          [outerList]="outerList"
          [formList]="formList"
          [formLOV]="formLOV"
          [parts]="f8941Parts"
          [presentTabClicked]="presentTabClicked"
          [subTableHeaderSelected]="subTableHeaderSelected"
          [formHeaderName]="getF8941FormHeaderName()"
          (innerTabSelect)="onF8941InnerTabSelect($event)"
          (fieldChange)="onFieldChange($event.item, $event.value)"
          (dateChange)="onDateChange($event.item, $event.event)"
          (dateVariousChange)="onDateVariousChange($event)"
          (dropdownChange)="onDropdownChange($event.item, $event.value)"
          (checkboxChange)="onCheckboxChange($event.item, $event.event)"
          (checkBox8941)="checkBoxHandler8941($event.lineKey, $event.attribKey, $event.attribCol)">
        </gtw-credits-part-iii-f8941>
      
}

      <!-- F8936 Wizard (PII/PV, currentYear >= 2024) -->
      @if (isF8936Wizard) {

        <gtw-credits-part-iii-f8936-wizard
          [activeWizardTab]="wizardActiveTab"
          [activeTab]="activeTab"
          [rowData]="rowData"
          [filterParams]="filterParams"
          [globalService]="globalService"
          [generalConfig]="GENERAL_CONFIG"
          [userSettings]="USER_SETTINGS"
          [formDataObj]="formDataObj"
          (tabSelect)="onWizardTabSelect($event)"
          (cancel)="cancel()">
          <div form8936>
            <ng-container *ngTemplateOutlet="defaultEntry"></ng-container>
          </div>
        </gtw-credits-part-iii-f8936-wizard>
      
}

      <!-- Default Entry (F7207/F4136/inne formy) -->
      @if (formNo !== 'F8820' && formNo !== 'F8912' && formNo !== 'F8941' && !isF8936Wizard) {

        <ng-container *ngTemplateOutlet="defaultEntry"></ng-container>
      
}
    </div>

    <ng-template #defaultEntry>
      @if (currentFormHeader) {
<h4 class="form-title">{{ currentFormHeader.DESCRIPTION }}</h4>
}

      <!-- F7207 (2024+) and F4136 (2025+) Part I rows -->
      @if (((formNo === 'F7207' && currentYear >= '2024') || (formNo === 'F4136' && currentYear >= '2025')) && outerListPreFormList.length > 0) {
<table class="table table-bordered custom-table"
            >
        <tbody>
          @for (row of outerListPreFormList; track $index) {
<tr>
            <ng-container *ngTemplateOutlet="cellRow; context: {row: row, list: preFormList}"></ng-container>
          </tr>
}
        </tbody>
      </table>
}

      <!-- F7207 Part I (<=2023): 4 checkboxy 48C -->
      @if (formNo === 'F7207' && currentYear && currentYear <= '2023' && preFormList.length >= 4) {
<table class="table table-bordered custom-table"
            >
        <tbody>
          <tr>
            <td>{{ preFormList[0].DESCRIPTION }}</td>
            <td>
              <label>
                <input type="checkbox"
                  [checked]="preFormList[0].ATTRIB_VALUE === 'true'"
                  (change)="onCheckboxChange(preFormList[0], $event)">
                {{ preFormList[0].ATTRIB_DESCRIPTION }}
              </label>
            </td>
            <td>
              <label>
                <input type="checkbox"
                  [checked]="preFormList[1].ATTRIB_VALUE === 'true'"
                  (change)="onCheckboxChange(preFormList[1], $event)">
                {{ preFormList[1].ATTRIB_DESCRIPTION }}
              </label>
            </td>
          </tr>
          <tr>
            <td>{{ preFormList[2].DESCRIPTION }}</td>
            <td>
              <label>
                <input type="checkbox"
                  [checked]="preFormList[2].ATTRIB_VALUE === 'true'"
                  (change)="onCheckboxChange(preFormList[2], $event)">
                {{ preFormList[2].ATTRIB_DESCRIPTION }}
              </label>
            </td>
            <td>
              <label>
                <input type="checkbox"
                  [checked]="preFormList[3].ATTRIB_VALUE === 'true'"
                  (change)="onCheckboxChange(preFormList[3], $event)">
                {{ preFormList[3].ATTRIB_DESCRIPTION }}
              </label>
            </td>
          </tr>
        </tbody>
      </table>
}

      <!-- Main table (Part II dla F7207, lub cała forma dla innych subForm) -->
      @if (outerList.length > 0) {
<table class="table table-bordered custom-table fixed-layout">
        <colgroup>
          <col style="width: 70px">
          <col style="width: 300px">
          @for (th of tableHeader; track $index; let i = $index) {
<col
               [style.width.px]="columnWidthsPx[i] || 180">
}
        </colgroup>
        <thead>
          <tr>
            <th class="sticky-col">{{ tableHeader[0]?.LINE_NO || 'Line Number' }}</th>
            <th class="sticky-col">{{ tableHeader[0]?.DESCRIPTION || 'Description' }}</th>
            @for (th of tableHeader; track $index) {
<th class="sticky-col">{{ th.ATTRIB_DESCRIPTION || th.DESCRIPTION || th.ATTRIB_SHORT_CODE }}</th>
}
          </tr>
        </thead>
        <tbody>
          @for (row of outerList; track $index) {
<tr>
            <ng-container *ngTemplateOutlet="cellRow; context: {row: row, list: formList}"></ng-container>
          </tr>
}
        </tbody>
      </table>
}

      <!-- F7207 postFormList: sekcja "Advanced Manufacturing Production Credit From Other Entities" -->
      @if (formNo === 'F7207' && postFormList.length >= 8) {
<table class="table table-bordered custom-table"
            >
        <tbody>
          <tr>
            <td class="color-red"><b>{{ postFormList[0].LINE_DISP }}</b></td>
            <td class="color-red"><b>{{ postFormList[0].DESCRIPTION }}</b></td>
          </tr>
          <tr>
            <td>{{ postFormList[2].LINE_DISP }}</td>
            <td>{{ postFormList[2].DESCRIPTION }}</td>
            <td>
              <input class="form-control input-sm" type="text" style="text-align: right;"
                [ngModel]="postFormList[2].ATTRIB_VALUE"
                (ngModelChange)="onFieldChange(postFormList[2], $event)">
            </td>
          </tr>
          <tr>
            <td class="color-red"><b>{{ postFormList[3].LINE_DISP }}</b></td>
            <td class="color-red"><b>{{ postFormList[3].DESCRIPTION }}</b></td>
          </tr>
          @for (idx of [5, 6, 7]; track $index) {
<tr>
            <td>{{ postFormList[idx].LINE_DISP }}</td>
            <td>{{ postFormList[idx].DESCRIPTION }}</td>
            <td>
              <input class="form-control input-sm" type="text" style="text-align: right;"
                [ngModel]="postFormList[idx].ATTRIB_VALUE"
                (ngModelChange)="onFieldChange(postFormList[idx], $event)">
            </td>
          </tr>
}
        </tbody>
      </table>
}

      <!-- F7207 Part IV (2024+): "Costs of Producing Applicable Critical Minerals" -->
      @if (formNo === 'F7207' && currentYear >= '2024' && partIVOuterList.length > 0) {
<table class="table table-bordered custom-table"
            >
        <tbody>
          @for (row of partIVOuterList; track $index) {
<tr>
            <ng-container *ngTemplateOutlet="cellRow; context: {row: row, list: partIVFormList}"></ng-container>
          </tr>
}
        </tbody>
      </table>
}

      <!-- Shared cell row template for Part I (2024+) and Part IV -->
      <ng-template #cellRow let-row="row" let-list="list">
        <td [ngClass]="{'color-red': row.ROW_TYPE === 'PH'}">
          @if (row.ROW_TYPE === 'PH') {
<b>{{ row.LINE_DISP }}</b>
}
          @if (row.ROW_TYPE !== 'PH') {
<span>{{ row.LINE_DISP }}</span>
}
        </td>
        <td [ngClass]="{'color-red': row.ROW_TYPE === 'PH'}">
          @if (row.ROW_TYPE === 'PH') {
<b>{{ row.DESCRIPTION || row.ATTRIB_DESCRIPTION }}</b>
}
          @if (row.ROW_TYPE !== 'PH') {
<span>{{ row.DESCRIPTION || row.ATTRIB_DESCRIPTION }}</span>
}
        </td>
        @if (row.EDIT_TYPE !== 'radio') {

          @for (item of getAttributeItemsFor(list, row.FORM_LINE_KEY); track $index) {
<td style="width: 180px;">
            @if (item.IS_EDITABLE_CELL !== 'Y' && item.EDIT_TYPE !== 'checkbox') {
<span
                  [style.display]="'block'"
                  [style.text-align]="(item.DATA_TYPE === 'number' || item.DATA_TYPE === 'decimal') ? 'right' : 'left'">
              {{ item.ATTRIB_VALUE }}
            </span>
}
            @if (item.IS_EDITABLE_CELL === 'Y' && item.EDIT_TYPE !== 'checkbox' && item.EDIT_TYPE !== 'custom_date_various' && item.EDIT_TYPE !== 'dropdown' && (item.DATA_TYPE === 'decimal' || isLatLongRow(item))) {
<input
             
              class="form-control input-sm"
              type="text"
              inputmode="decimal"
              onlyDigitsDecimal
              style="text-align: right;"
              [ngModel]="item.ATTRIB_VALUE"
              (ngModelChange)="onFieldChange(item, $event)">
}
            @if (item.IS_EDITABLE_CELL === 'Y' && item.EDIT_TYPE !== 'checkbox' && item.EDIT_TYPE !== 'custom_date_various' && item.EDIT_TYPE !== 'dropdown' && item.DATA_TYPE !== 'decimal' && !isLatLongRow(item)) {
<input
             
              class="form-control input-sm"
              type="text"
              [style.text-align]="(item.DATA_TYPE === 'number' || item.EDIT_TYPE === 'currency') ? 'right' : 'left'"
              [ngModel]="item.ATTRIB_VALUE"
              (ngModelChange)="onFieldChange(item, $event)">
}
            @if (item.EDIT_TYPE === 'checkbox') {
<label style="padding-left: 25px;">
              <input type="checkbox"
                [checked]="item.ATTRIB_VALUE === 'true'"
                (change)="onCheckboxChange(item, $event)">
              {{ item.ATTRIB_DESCRIPTION }}
            </label>
}
            @if (item.EDIT_TYPE === 'dropdown') {
<select
             
              style="width: 100%; max-width: 100%;"
              class="form-control"
              [ngModel]="item.ATTRIB_VALUE"
              (ngModelChange)="onDropdownChange(item, $event)">
              <option value="">Select</option>
              @for (option of (formNo === 'F4136' ? (lineFuelCodesMap[row.LINE_NO] || []) : formLOV); track $index) {
<option
               
                [value]="formNo === 'F4136' ? option.FUEL_CODE : option.CODE_NAME">
                {{ formNo === 'F4136' ? option.FUEL_DESC : option.CODE_DESC }}
              </option>
}
            </select>
}
            @if (item.EDIT_TYPE === 'custom_date_various') {
<gtw-credits-date-various
             
              [row]="item"
              (changed)="onDateVariousChange(item)">
            </gtw-credits-date-various>
}
          </td>
}
        
}
        @if (row.EDIT_TYPE === 'radio') {
<td style="width: 183px; text-align: left;">
          @for (radioItem of getRadioItemsFrom(list, row.FORM_LINE_KEY); track $index) {
<div>
            <label>
              <input type="checkbox"
                [checked]="radioItem.ATTRIB_VALUE === 'true'"
                (change)="onRadioChangeIn(list, radioItem)">
              {{ radioItem.ATTRIB_DESCRIPTION }}
            </label>
          </div>
}
        </td>
}
      </ng-template>

      <!-- F7218 Part III: multi-row line 1 table (columns a-h) -->
      @if (showF7218PartIIISection) {
        <table class="table table-bordered custom-table f7218-part-iii-title-table">
          <tbody>
            @if (f7218PartIIIHeader) {
            <tr>
              <td class="color-red"><b>{{ f7218PartIIIHeader.LINE_DISP }}</b></td>
              <td class="color-red" [attr.colspan]="f7218PartIIIColumns.length"><b>{{ f7218PartIIIHeader.DESCRIPTION }}</b></td>
            </tr>
            }
          </tbody>
        </table>
        <div class="f7218-part-iii-scroll">
          <table class="table table-bordered custom-table f7218-part-iii-table">
            <thead class="f7218-part-iii-thead">
              <tr>
                <th style="width: 50px;"></th>
                @for (col of f7218PartIIIColumns; track $index) {
                <th>{{ col.ATTRIB_DESCRIPTION }}</th>
                }
              </tr>
            </thead>
            <tbody>
              <tr>
                <td [attr.colspan]="f7218PartIIIColumns.length + 1">
                  <i class="fa fa-plus-circle color-green fa-sm pull-left f7218-add-row"
                    style="cursor: pointer; margin-top: 4px;"
                    title="Add Row"
                    aria-label="Add Row"
                    role="button"
                    tabindex="0"
                    (click)="addF7218PartIIIRow()">Add Row</i>
                </td>
              </tr>
              @for (row of f7218PartIIIRows; track $index) {
              <tr>
                <td>
                  <i class="fa fa-minus-circle color-red fa-sm pull-left f7218-delete-row"
                    style="cursor: pointer; margin-top: 4px;"
                    [attr.title]="'Delete row ' + ($index + 1)"
                    [attr.aria-label]="'Delete row ' + ($index + 1)"
                    role="button"
                    tabindex="0"
                    (click)="deleteF7218PartIIIRow($index)">{{ $index + 1 }}</i>
                </td>
                @for (col of f7218PartIIIColumns; track $index) {
                <td>
                  @if (getF7218CellForColumn(row, col); as cell) {
                    @if (isF7218DateVariousCell(cell)) {
                    <gtw-credits-date-various
                      [row]="cell"
                      (changed)="onDateVariousChange(cell)">
                    </gtw-credits-date-various>
                    }
                    @if (cell.IS_EDITABLE_CELL === 'Y' && !isF7218CalculatedCell(cell) && !isF7218DateVariousCell(cell) && cell.EDIT_TYPE === 'dropdown') {
                    <select
                      style="width: 100%; max-width: 100%;"
                      class="form-control"
                      [ngModel]="cell.ATTRIB_VALUE"
                      (ngModelChange)="onDropdownChange(cell, $event)">
                      <option value="">Select</option>
                      @for (option of formLOV; track $index) {
                      <option [value]="option.CODE_NAME">
                        {{ option.CODE_DESC }}
                      </option>
                      }
                    </select>
                    }
                    @if (cell.IS_EDITABLE_CELL === 'Y' && !isF7218CalculatedCell(cell) && !isF7218DateVariousCell(cell) && cell.EDIT_TYPE !== 'dropdown' && (cell.DATA_TYPE === 'decimal' || cell.DATA_TYPE === 'number' || cell.EDIT_TYPE === 'currency')) {
                    <input
                      class="form-control input-sm" type="text" inputmode="decimal" onlyDigitsDecimal
                      style="text-align: right;" [ngModel]="cell.ATTRIB_VALUE"
                      (ngModelChange)="onFieldChange(cell, $event)">
                    }
                    @if (cell.IS_EDITABLE_CELL === 'Y' && !isF7218CalculatedCell(cell) && !isF7218DateVariousCell(cell) && cell.EDIT_TYPE !== 'dropdown' && cell.DATA_TYPE !== 'decimal' && cell.DATA_TYPE !== 'number' && cell.EDIT_TYPE !== 'currency') {
                    <input
                      class="form-control input-sm" type="text" [ngModel]="cell.ATTRIB_VALUE"
                      (ngModelChange)="onFieldChange(cell, $event)">
                    }
                    @if (isF7218CalculatedCell(cell)) {
                    <span class="f7218-calc-value">
                      {{ cell.ATTRIB_VALUE | numberWithCommas }}
                    </span>
                    }
                    @if (!isF7218EditableInput(cell) && !isF7218CalculatedCell(cell) && !isF7218DateVariousCell(cell)) {
                    <span
                      [style.display]="'block'"
                      [style.text-align]="(cell.DATA_TYPE === 'number' || cell.DATA_TYPE === 'decimal') ? 'right' : 'left'">
                      {{ (cell.DATA_TYPE === 'number' || cell.DATA_TYPE === 'decimal')
                        ? (cell.ATTRIB_VALUE | numberWithCommas)
                        : cell.ATTRIB_VALUE }}
                    </span>
                    }
                  }
                </td>
                }
              </tr>
              }
            </tbody>
          </table>
        </div>
        <!-- Line 2 total — outside scroll; label and (h) total on one row, total under column (h) -->
        @if (showF7218PartIIITable && f7218PartIIIColumns.length > 0) {
        <table class="table table-bordered custom-table f7218-part-iii-total-table">
          <tbody>
            <tr class="f7218-part-iii-line2-row">
              <td class="f7218-part-iii-line2-index"></td>
              <td class="f7218-part-iii-line2-label" [attr.colspan]="f7218PartIIIColumns.length - 1">
                <strong>{{ f7218PartIIILine2Label }}</strong>
              </td>
              <td class="f7218-part-iii-line2-value">
                <strong>{{ getF7218PartIIIColumnHTotal() | numberWithCommas }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
        }
      }

      @if (outerList.length === 0 && preFormList.length === 0 && postFormList.length === 0 && partIVOuterList.length === 0 && !showF7218PartIIITable) {
<p>No form data available.</p>
}
    </ng-template>
  </div>
}
</div>

<!--
  The outer modal footer is hidden on the F8936 wizard's "Schedule A" tab,
  because that tab provides its own contextual footer (saveSchdA / resetSchdA
  / cancelFormSchdA). On every other view a single set of Save / Reset /
  Cancel buttons remains for the main form save.
-->
<div class="modal-footer"
     [hidden]="minimise || (isF8936Wizard && wizardActiveTab === 'Schedule A')">
  <button class="save-button" type="button" [disabled]="isSaveClicked || crudLoading" (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="reset-button" type="button" [disabled]="crudLoading" (click)="reset()">Reset</button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
